/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Agent_Knowledge_BlurbInputs */



/**
* | output |
* | --- |
* | "Knowledge spaces are the documents your agent may read. It only looks in the spaces you pick here." |
*
* @param {Uno_Edu_Agent_Knowledge_BlurbInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_agent_knowledge_blurb = /** @type {((inputs?: Uno_Edu_Agent_Knowledge_BlurbInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Agent_Knowledge_BlurbInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wissensbereiche sind die Dokumente, die Ihr Agent lesen darf. Er sieht nur in den Bereichen nach, die Sie hier auswählen.")
	return /** @type {LocalizedString} */ ("Knowledge spaces are the documents your agent may read. It only looks in the spaces you pick here.")
});